import Loader from './components/Loader';
import React from 'react';

export default (
	children,
	props,
	childrenPropMap = props => props,
	waiting = () => false
) => {
	if (waiting(props)) return <Loader />;
	if (props.loading) return <Loader />;
	if (props.error) return <div>error: {props.error.message}</div>;
	const childrenProps = childrenPropMap(props);
	switch (typeof children) {
	case 'function':
		return children(childrenProps);
	case 'object':
		if (Array.isArray(children)) {
			return children.map(child => {
				switch (typeof child) {
				case 'function':
					return child(childrenProps);
				case 'object':
					return React.cloneElement(child, childrenProps);
				default:
					return child;
				}
			});
		} else {
			return React.cloneElement(children, childrenProps);
		}
	default:
		return children;
	}
};
